/* eslint-disable class-methods-use-this */
export default class Pager {
    constructor() {
        this.templateInfos = {
            activePagerBulletclass: 'pager-item--current'
        };
    }

    getTplDOM(dataToPopulateHTML, tplType = 'default') {
        const {currentPage} = dataToPopulateHTML;
        const pagerUrl = `${window.location.origin}${window.location.pathname}`;

        if(tplType === 'default') {
            return totalPages => `
                <li class="pager-item--wrapper list__item--no-style">
                    <a
                    href="${pagerUrl}?page=${totalPages}"
                    class="flex--v-center inflex text text--blue-azure text--center btn--reset pager-item mb0 clickable ${currentPage === totalPages ? 'pager-item--current' : ''}"
                    data-page-nb="${totalPages}">
                        ${totalPages}
                    </a>
                </li>`;
        }

        return '';
    }
}
